import React from "react";
import { NavLink } from "react-router-dom";

// Page title for the Statement and Statement History pages. The pages sit on
// the app's dark background, so the title is light; the button switches
// between the two pages.
export default function StatementHeader({ icon: Icon, title, subtitle, link }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
      <div className="flex items-center gap-3 min-w-0">
        <div className="shrink-0 w-11 h-11 rounded-xl bg-white/10 ring-1 ring-white/20 flex items-center justify-center">
          <Icon className="text-white text-xl" />
        </div>
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-white">{title}</h1>
          <p className="text-sm text-slate-300 mt-0.5">{subtitle}</p>
        </div>
      </div>
      {link && (
        <NavLink
          to={link.to}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium
                     bg-white/10 text-white ring-1 ring-white/20 hover:bg-white/20 transition-colors"
        >
          <link.icon />
          {link.label}
        </NavLink>
      )}
    </div>
  );
}
